import { render, staticRenderFns } from "./PlanEstudio.vue?vue&type=template&id=48422fa4&scoped=true"
import script from "./PlanEstudio.vue?vue&type=script&lang=js"
export * from "./PlanEstudio.vue?vue&type=script&lang=js"
import style0 from "./PlanEstudio.vue?vue&type=style&index=0&id=48422fa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48422fa4",
  null
  
)

export default component.exports